export default function() {
  return new Worker(__webpack_public_path__ + "static/js/main.3b0d2b01.worker.js");
}
